import React, { useMemo } from 'react';
import creditCardType from 'util/creditCardType';

import { Box, BoxProps } from '@mui/material';

import VisaIcon from 'assets/icons/credit-card-flags/visa.png';
import MastercardIcon from 'assets/icons/credit-card-flags/mastercard.png';
import AmericanExpressIcon from 'assets/icons/credit-card-flags/american_express.png';
import DinersClubIcon from 'assets/icons/credit-card-flags/diners_club.png';
import DiscoverIcon from 'assets/icons/credit-card-flags/discover.png';
import JcbIcon from 'assets/icons/credit-card-flags/jcb.png';
import UnionpayIcon from 'assets/icons/credit-card-flags/unionpay.png';
import MaestroIcon from 'assets/icons/credit-card-flags/maestro.png';
import MirIcon from 'assets/icons/credit-card-flags/mir.png';
import EloIcon from 'assets/icons/credit-card-flags/elo.png';
import HiperIcon from 'assets/icons/credit-card-flags/hiper.png';
import HipercardIcon from 'assets/icons/credit-card-flags/hipercard.png';
import GenericIcon from 'assets/icons/credit-card-flags/generic.png';

const CreditCardLogos = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  'american-express': AmericanExpressIcon,
  amex: AmericanExpressIcon,
  'diners-club': DinersClubIcon,
  diners: DinersClubIcon,
  discover: DiscoverIcon,
  jcb: JcbIcon,
  unionpay: UnionpayIcon,
  maestro: MaestroIcon,
  mir: MirIcon,
  elo: EloIcon,
  hiper: HiperIcon,
  hipercard: HipercardIcon,
  generic: GenericIcon,
};

interface Props extends BoxProps {
  cardNumber?: string;
  cardFlag?: string;
  alt?: string;
}

export const CreditCardFlag: React.FC<Props> = ({
  cardNumber,
  cardFlag,
  ...props
}) => {
  const flag = useMemo(() => {
    const type = creditCardType(cardNumber as string)?.[0]?.type ?? cardFlag;

    if (!type) {
      return CreditCardLogos.generic;
    }

    // @ts-ignore
    return CreditCardLogos[type];
  }, [cardNumber, cardFlag]);

  return (
    <Box
      component="img"
      alt="Flag"
      width={45}
      // heght={30}
      src={flag}
      {...props}
    />
  );
};
